// extracted by mini-css-extract-plugin
export var defaultWrapper = "_md-3";
export var downloadButton = "_md-4";
export var fileContainer = "_md-9 _md-7";
export var fileContainerBase = "_md-7";
export var fileContainerFixedHeight = "_md-8 _md-7";
export var fileInfo = "_md-5";
export var fileInfoWidthRestricted = "_md-6";
export var fileType = "_md-1";
export var fileTypeName = "_md-2";
export var image = "_md-0";
export var link = "_md-b";
export var overflowEllipsis = "_md-a";